module.exports = __webpack_public_path__ + "img/desc5.e95ac85f.jpg";